import {
  asyncActionTypeFailure,
  asyncActionTypeRequest,
  asyncActionTypeSuccess,
} from 'views/AddProduct/types';
import get from 'lodash/get';
import actionTypes from './types';
import {
  defaultList
} from '../newStore/utils';

export default (state, action) => {
  switch (action.type) {
    case actionTypes.SELECT_SM_SUPPLIER: {
      return {
        ...state,
        productTab: {
          ...defaultList,
        },
      };
    }
    case asyncActionTypeRequest(actionTypes.UPDATE_SM_SUPPLIER_STATUS): {
      return {
        ...state,
        smSupplierDetail: {
          ...state.smSupplierDetail,
          loading: true,
        }
      }
    }
    case asyncActionTypeSuccess(actionTypes.UPDATE_SM_SUPPLIER_STATUS): {
      return {
        ...state,
        smSupplierDetail: {
          loading: false,
          data: get(action, 'response.data') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(actionTypes.UPDATE_SM_SUPPLIER_STATUS): {
      return {
        ...state,
        smSupplierDetail: {
          ...state.smSupplierDetail,
          data: {},
          loading: false,
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(actionTypes.GET_SM_SUPPLIER_LIST): {
      return {
        ...state,
        smSupplierList: {
          ...state.smSupplierList,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(actionTypes.GET_SM_SUPPLIER_LIST): {
      return {
        ...state,
        smSupplierList: {
          ...state.smSupplierList,
          data: get(action, 'response.data.list') || {},
          total: get(action, 'response.data.pagination.total') || 0,
          loading: false,
        },
      };
    }
    case asyncActionTypeFailure(actionTypes.GET_SM_SUPPLIER_LIST): {
      return {
        ...state,
        smSupplierList: {
          ...state.smSupplierList,
          data: [],
          loading: false,
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(actionTypes.GET_SM_SUPPLIER_QUANTITY): {
      return {
        ...state,
        smSupplierList: {
          ...state.smSupplierList,
        },
      };
    }
    case asyncActionTypeSuccess(actionTypes.GET_SM_SUPPLIER_QUANTITY): {
      return {
        ...state,
        smSupplierList: {
          ...state.smSupplierList,
          quantity: get(action, 'response.data') || 0,
        },
      };
    }
    case asyncActionTypeFailure(actionTypes.GET_SM_SUPPLIER_QUANTITY): {
      return {
        ...state,
        smSupplierList: {
          ...state.smSupplierList,
        },
      };
    }
    case actionTypes.UPDATE_SM_SUPPLIER_LIST_PAGINATION: {
      return {
        ...state,
        smSupplierList: {
          ...state.smSupplierList,
          pagination: action.payload.pagination,
        },
      };
    }
    case actionTypes.UPDATE_SM_SUPPLIER_LIST_FILTER: {
      return {
        ...state,
        smSupplierList: {
          ...state.smSupplierList,
          filter: action.payload.filter,
        },
      };
    }
    case actionTypes.UPDATE_SM_SUPPLIER_LIST_SORTER: {
      return {
        ...state,
        smSupplierList: {
          ...state.smSupplierList,
          sorter: action.payload.sorter,
        },
      };
    }
    case actionTypes.UPDATE_SM_SUPPLIER_LIST_SEARCH: {
      return {
        ...state,
        smSupplierList: {
          ...state.smSupplierList,
          search: action.payload.search,
        },
      };
    }
    case asyncActionTypeRequest(actionTypes.GET_SM_FACTORY_LIST): {
      return {
        ...state,
        smFactoryList: {
          ...state.smFactoryList,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(actionTypes.GET_SM_FACTORY_LIST): {
      return {
        ...state,
        smFactoryList: {
          ...state.smFactoryList,
          data: get(action, 'response.data.list') || {},
          total: get(action, 'response.data.pagination.total') || 0,
          loading: false,
        },
      };
    }
    case asyncActionTypeFailure(actionTypes.GET_SM_FACTORY_LIST): {
      return {
        ...state,
        smFactoryList: {
          ...state.smFactoryList,
          data: [],
          loading: false,
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(actionTypes.GET_SM_FACTORY_LIST_BY_SUPPLIER_ID): {
      return {
        ...state,
        smSupplierFactoryList: {
          ...state.smSupplierFactoryList,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(actionTypes.GET_SM_FACTORY_LIST_BY_SUPPLIER_ID): {
      return {
        ...state,
        smSupplierFactoryList: {
          ...state.smSupplierFactoryList,
          data: get(action, 'response.data.list') || {},
          total: get(action, 'response.data.pagination.total') || 0,
          loading: false,
        },
      };
    }
    case asyncActionTypeFailure(actionTypes.GET_SM_FACTORY_LIST_BY_SUPPLIER_ID): {
      return {
        ...state,
        smSupplierFactoryList: {
          ...state.smSupplierFactoryList,
          data: [],
          loading: false,
          error: get(action, 'error'),
        },
      };
    }
    case actionTypes.UPDATE_SM_FACTORY_LIST_PAGINATION: {
      return {
        ...state,
        smFactoryList: {
          ...state.smFactoryList,
          pagination: action.payload.pagination,
        },
      };
    }
    case actionTypes.UPDATE_SM_FACTORY_LIST_FILTER: {
      return {
        ...state,
        smFactoryList: {
          ...state.smFactoryList,
          filter: action.payload.filter,
        },
      };
    }
    case actionTypes.UPDATE_SM_FACTORY_LIST_SORTER: {
      return {
        ...state,
        smFactoryList: {
          ...state.smFactoryList,
          sorter: action.payload.sorter,
        },
      };
    }
    case actionTypes.UPDATE_SM_FACTORY_LIST_SEARCH: {
      return {
        ...state,
        smFactoryList: {
          ...state.smFactoryList,
          search: action.payload.search,
        },
      };
    }
    case asyncActionTypeRequest(actionTypes.GET_SM_FACTORY_QUANTITY): {
      return {
        ...state,
        smFactoryList: {
          ...state.smFactoryList,
        },
      };
    }
    case asyncActionTypeSuccess(actionTypes.GET_SM_FACTORY_QUANTITY): {
      return {
        ...state,
        smFactoryList: {
          ...state.smFactoryList,
          quantity: get(action, 'response.data') || 0,
        },
      };
    }
    case asyncActionTypeFailure(actionTypes.GET_SM_FACTORY_QUANTITY): {
      return {
        ...state,
        smFactoryList: {
          ...state.smFactoryList,
        },
      };
    }
    default:
      return state;
  }
};